/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { HTMLAttributes } from 'preact/compat';
import { Container } from '@adobe-commerce/elsie/lib';
import { VNode } from 'preact';
import { OrderSummaryLine as OrderSummaryLineComponent } from '@/quote-management/components';

export interface OrderSummaryLineProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'label'> {
  label: VNode | string;
  price: VNode<HTMLAttributes<HTMLSpanElement>>;
  classSuffixes?: Array<string>;
  labelClassSuffix?: string;
  testId?: string;
  children?: any;
}

export const OrderSummaryLine: Container<OrderSummaryLineProps> = ({
  label,
  price,
  classSuffixes = [],
  labelClassSuffix,
  testId,
  children,
  ...props
}) => {
  return (
    <OrderSummaryLineComponent
      {...props}
      label={label}
      price={price}
      classSuffixes={classSuffixes}
      labelClassSuffix={labelClassSuffix}
      testId={testId}
    >
      {children}
    </OrderSummaryLineComponent>
  );
};
